var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgO2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 28,
    viewBox: "0 0 65 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2348_1576)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 28,
    rx: 10,
    fill: "#CAD6FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7087 11.8V10.252H37.6007V19H35.8727V11.8H34.7087ZM39.2603 14.512C39.2603 13.128 39.5083 12.044 40.0043 11.26C40.5083 10.476 41.3403 10.084 42.5003 10.084C43.6603 10.084 44.4883 10.476 44.9843 11.26C45.4883 12.044 45.7403 13.128 45.7403 14.512C45.7403 15.904 45.4883 16.996 44.9843 17.788C44.4883 18.58 43.6603 18.976 42.5003 18.976C41.3403 18.976 40.5083 18.58 40.0043 17.788C39.5083 16.996 39.2603 15.904 39.2603 14.512ZM44.0843 14.512C44.0843 13.92 44.0443 13.424 43.9643 13.024C43.8923 12.616 43.7403 12.284 43.5083 12.028C43.2843 11.772 42.9483 11.644 42.5003 11.644C42.0523 11.644 41.7123 11.772 41.4803 12.028C41.2563 12.284 41.1043 12.616 41.0243 13.024C40.9523 13.424 40.9163 13.92 40.9163 14.512C40.9163 15.12 40.9523 15.632 41.0243 16.048C41.0963 16.456 41.2483 16.788 41.4803 17.044C41.7123 17.292 42.0523 17.416 42.5003 17.416C42.9483 17.416 43.2883 17.292 43.5203 17.044C43.7523 16.788 43.9043 16.456 43.9763 16.048C44.0483 15.632 44.0843 15.12 44.0843 14.512ZM51.1462 19L48.8902 16.168V19H47.2102V10.12H48.8902V15.172L51.1222 12.352H53.3062L50.3782 15.688L53.3302 19H51.1462Z",
    fill: "#2A2A2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.307 20.9194C27.3614 20.9266 27.4159 20.934 27.4703 20.9417L27.7438 20.9801C28.9346 21.1472 30 20.2395 30 19.0579V18.1562C30 17.3111 29.4592 16.5573 28.649 16.2731C27.7129 15.9447 26.7466 15.7309 25.7711 15.6316C26.789 16.3675 27.4203 17.5592 27.4203 18.8594V19.979C27.4203 20.3041 27.3809 20.619 27.307 20.9194ZM23.1812 14.432C23.5868 14.5995 24.0324 14.692 24.5 14.692C26.3813 14.692 27.9064 13.1939 27.9064 11.346C27.9064 9.49801 26.3813 7.99994 24.5 7.99994C24.4443 7.99994 24.3889 8.00125 24.3338 8.00385C24.6759 8.73246 24.8671 9.546 24.8671 10.4042C24.8671 11.9807 24.2219 13.4065 23.1812 14.432Z",
    fill: "#2A2A2B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0739 20.9194C11.0194 20.9266 10.965 20.934 10.9106 20.9417L10.6371 20.9801C9.44625 21.1472 8.38084 20.2395 8.38084 19.0579V18.1562C8.38084 17.3111 8.92166 16.5573 9.73185 16.2731C10.6679 15.9447 11.6343 15.7309 12.6098 15.6316C11.5919 16.3675 10.9606 17.5592 10.9606 18.8594V19.979C10.9606 20.3041 10.9999 20.619 11.0739 20.9194ZM15.1997 14.432C14.7941 14.5995 14.3485 14.692 13.8808 14.692C11.9995 14.692 10.4744 13.1939 10.4744 11.346C10.4744 9.49801 11.9995 7.99994 13.8808 7.99994C13.9366 7.99994 13.992 8.00125 14.0471 8.00385C13.705 8.73246 13.5138 9.546 13.5138 10.4042C13.5138 11.9807 14.159 13.4065 15.1997 14.432Z",
    fill: "#2A2A2B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3671 10.4042C23.3671 8.10986 21.5071 6.24994 19.2128 6.24994C16.9185 6.24994 15.0586 8.10986 15.0586 10.4042C15.0586 12.6985 16.9185 14.5584 19.2128 14.5584C21.5071 14.5584 23.3671 12.6985 23.3671 10.4042Z",
    fill: "#2A2A2B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.153 16.5214C17.425 15.3528 21.0006 15.3528 24.2727 16.5214C25.2607 16.8743 25.9203 17.8102 25.9203 18.8594V19.979C25.9203 21.4459 24.621 22.5728 23.1687 22.3654L22.8351 22.3177C20.4325 21.9745 17.9932 21.9745 15.5905 22.3177L15.2569 22.3654C13.8047 22.5728 12.5054 21.4459 12.5054 19.979V18.8594C12.5054 17.8102 13.1649 16.8743 14.153 16.5214Z",
    fill: "#2A2A2B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2348_1576",
    x: -200,
    y: -200,
    width: 465,
    height: 428,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 100
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2348_1576"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2348_1576",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgO2);
export default __webpack_public_path__ + "static/media/o2.55d6078aeac586b4fa3e56c43fec143e.svg";
export { ForwardRef as ReactComponent };